import { type Score } from "./types";

export const sectionScores = {
  transport: [
    "pedestrian_friendly",
    "car_friendly",
    "transit_friendly",
    "cycling_friendly",
  ] as Score[],
  services: ["groceries", "shopping", "restaurants", "cafes"] as Score[],
  character: ["quiet", "parks", "vibrant", "nightlife"] as Score[],
};

export const includeScores = [
  ...sectionScores.transport,
  ...sectionScores.services,
  ...sectionScores.character,
];
